export default __webpack_public_path__ + "static/cyclist-66f290e2322d100bfaab5ef2a9888f35.png";